import { useSelector } from "react-redux";
import {
  AreaChart,
  Area,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import "./chart.scss";

const Chart = ({ aspect, title }) => {
  const prestamos = useSelector((state) => state.allPrestamos);
  
  const data = [
    { name: "Febrero", Total: 5 },
    { name: "Marzo", Total: 2 },
    { name: "Abril", Total: 0 },
    { name: "Mayo", Total: 2 },
    { name: "Junio", Total: 3 },
    { name: "Julio", Total: prestamos.length },
  ];
  
  return (
    <div className="chart">
      <div className="title">{title}</div>
      <ResponsiveContainer width="100%" aspect={aspect}>
        <AreaChart
          width={730}
          height={250}
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#424242" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#424242" stopOpacity={0} />
            </linearGradient>
          </defs>
          
          <XAxis dataKey="name" stroke="gray" />
          <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
          <Tooltip />

          <Area
            type="monotone"
            dataKey="Total"
            stroke="#424242"
            fillOpacity={1}
            fill="url(#total)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;
